import React, { useEffect, useState } from 'react'
import { Flexbox, Form } from '@/components'
import passwordReset from '@/services/auth/passwordReset'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'

function Email({
  email,
  values,
  errors,
  touched,
  setFieldValue,
  onEmailSentChange,
}) {
  const [emailSent, setEmailSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [timer, setTimer] = useState(0)

  useEffect(() => {
    if (!emailSent || timer <= 0) return undefined
    const interval = setInterval(() => setTimer((t) => t - 1), 1000)
    return () => clearInterval(interval)
  }, [emailSent, timer])

  useEffect(() => {
    onEmailSentChange(emailSent)
  }, [emailSent, onEmailSentChange])

  const handleSendEmail = async () => {
    if (!email) {
      toast.error('Não foi possível identificar seu e-mail.')
      return
    }
    setLoading(true)
    try {
      await passwordReset.sendEmail(email)
      setEmailSent(true)
      setTimer(60)
      toast.success('E-mail enviado')
    } catch (err) {
      toast.error('Erro ao enviar o e-mail.')
    } finally {
      setLoading(false)
    }
  }

  const handleResendEmail = async () => {
    setLoading(true)
    try {
      await passwordReset.sendEmail(email)
      setTimer(60)
      toast.success('E-mail reenviado')
    } catch (err) {
      toast.error('Erro ao reenviar o e-mail.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="p-2 text-center">
      {!emailSent ? (
        <>
          <div className="mb-2 pb-2">
            Um e-mail será enviado para <b>{email}</b> com um código de 6 dígitos.
            <div>Informe o código para alterar sua senha.</div>
          </div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSendEmail}
            disabled={loading}
          >
            {loading ? (
              <i className="fas fa-spinner fa-spin mr-1" />
            ) : (
              <i className="fas fa-envelope mr-1" />
            )}
            &nbsp;Enviar código para meu e-mail
          </button>
        </>
      ) : (
        <>
          <div>Informe o código de 6 dígitos que enviamos para:</div>
          <b>{email}</b>
          <Flexbox.Columns className="flex-centered">
            <Flexbox.Column className="col-2 mt-2 mb-1">
              <Form.Group className="mt-2 pt-2">
                <Form.ValidationField
                  id="token"
                  name="token"
                  value={values.token || ''}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/\D/g, '')
                    setFieldValue('token', numericValue)
                  }}
                  maxLength={6}
                  className="text-center"
                  autoFocus
                  placeholder="000000"
                />
                {errors?.token && touched?.token && (
                  <Form.Hint className="text-error mt-1">
                    {errors.token}
                  </Form.Hint>
                )}
              </Form.Group>
            </Flexbox.Column>
          </Flexbox.Columns>

          <div className="mt-2">
            {timer > 0 ? (
              <small>
                Você poderá reenviar o e-mail em <b>{timer}s</b>
              </small>
            ) : (
              <button
                type="button"
                className="btn btn-link p-0"
                onClick={handleResendEmail}
                disabled={loading}
              >
                <i className="fas fa-redo mr-1" />
                {' '}
                Reenviar e-mail
              </button>
            )}
          </div>
        </>
      )}
    </div>
  )
}

Email.propTypes = {
  email: PropTypes.string,
  values: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  onEmailSentChange: PropTypes.func.isRequired,
}

Email.defaultProps = {
  email: null,
}

export default Email
